import React from "react";
import logo from "../../Assets/logo.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <footer className="bd-footer py-4 py-md-5 mt-1 bg-dark">
        <div className="container py-4 py-md-5 px-4 px-md-3">
          <div className="row">
            <div className="col-lg-3 mb-3">
              <a
                className="d-inline-flex align-items-center mb-2 link-dark text-decoration-none"
                href="/"
              >
                <img src={logo} alt="" height="auto" width="50%" />
              </a>
              <ul className="list-unstyled small text-muted">
                <li className="mb-2">
                  <p style={{ color: "white" }}>
                    I'm a MERN stack developer, Firebase and PHP developer. I'm
                    passionate about building high-quality, scalable, and
                    efficient web applications that meet the needs of users and
                    clients alike. If you're interested in working with me or
                    learning more about my skills and experience, please don't
                    hesitate to reach out!
                  </p>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 mb-3 px-5">
              <h5>Quick Links</h5>
              <br />
              <ul className="list-unstyled">
                <li className="mb-2">
                  <Link
                    to="/contact"
                    style={{ textDecoration: "none" }}
                    className="footer-link"
                  >
                    <i class="bi bi-caret-right"></i>
                    &nbsp;CONTACT
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li className="mb-2">
                  <Link
                    to="/about"
                    style={{ textDecoration: "none" }}
                    className="footer-link"
                  >
                    <i class="bi bi-caret-right"></i>
                    &nbsp;ABOUT
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li className="mb-2">
                  <Link
                    to="/feedback"
                    style={{ textDecoration: "none" }}
                    className="footer-link"
                  >
                    <i class="bi bi-caret-right"></i>
                    &nbsp;FEEDBACK
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li className="mb-2">
                  <Link
                    to="/shell/login"
                    style={{ textDecoration: "none" }}
                    className="footer-link"
                  >
                    <i class="bi bi-caret-right"></i>
                    &nbsp;LOGIN
                  </Link>
                </li>
                <hr className="dropdown-divider" />
              </ul>
            </div>
            <div className="col-lg-3 mb-3">
              <h5>For Clients & Recruiter</h5>
              <br />
              <ul className="list-unstyled">
                <li className="mb-2">
                  <Link to="/services" className="footer-link">
                    <i class="bi bi-caret-right"></i>
                    &nbsp;SERVICES
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li className="mb-2">
                  <Link to="/online-resume" className="footer-link">
                    <i class="bi bi-caret-right"></i>
                    &nbsp;ONLINE RESUME
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/projects" className="footer-link">
                    <i class="bi bi-caret-right"></i>
                    &nbsp;PROJECTS
                  </Link>
                </li>
                <li className="mb-2">
                  <Link to="/book-meeting" className="footer-link">
                    <i class="bi bi-caret-right"></i>
                    &nbsp;BOOK MEETING
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
              </ul>
            </div>
            <div className="col-lg-3 mb-3">
              <h5>Get In Touch</h5>
              <br />
              <ul className="list-unstyled">
                <li className="mb-2">
                  <p className="small">
                    <a
                      href="https://api.whatsapp.com/send/?phone=923062341354&text&type=phone_number&app_absent=0"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="bi bi-telephone"></i> &nbsp; Whatsapp +92
                      306-2341354{" "}
                    </a>
                    <br />
                  </p>
                </li>
                <li className="mb-2">
                  {/* <i className="bi bi-envelope"></i> */}
                  <a href="mailto:aneequllah.khan@outlook.com">
                    aneequllah.khan@outlook.com
                  </a>
                </li>

                <li className="mb-2">
                  <i className="bi bi-geo-alt-fill"></i> Headoffice:
                  &nbsp;Karachi, Pakistan.
                  <br />
                </li>
                <li className="mb-3">
                  <a
                    href="https://www.linkedin.com/in/aneeq-ullah-khan/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      width="40"
                      height="40"
                      src="https://img.icons8.com/fluency/48/linkedin.png"
                    />
                  </a>
                  <a
                    href="https://github.com/AneeqUllahKhan"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      width="40"
                      height="40"
                      src="https://img.icons8.com/ios-filled/50/github.png"
                    />
                  </a>
                  <a
                    href="https://www.fiverr.com/aneeqkhan17"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      width="40"
                      height="40"
                      src="https://img.icons8.com/color/48/fiverr.png"
                    />
                  </a>
                  <a
                    href="https://www.facebook.com/Aneequllahkhan.18/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      width="40"
                      height="40"
                      src="https://img.icons8.com/color/48/facebook-new.png"
                      alt="facebook-new"
                    />
                  </a>
                  <a
                    href="https://www.instagram.com/aneeqprivv_/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      width="40"
                      height="40"
                      src="https://img.icons8.com/fluency/48/instagram-new.png"
                      alt="instagram-new"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      <div style={{ backgroundColor: "#0F0F0F", height: "50px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <p
                className="small"
                style={{ paddingTop: "12px", color: "gray" }}
              >
                &copy; 2023 &nbsp;
                <Link to="/" style={{ color: "white", textDecoration: "none" }}>
                  Aneeq Ullah Khan &nbsp;
                </Link>
                | All Rights Reserved.
              </p>
            </div>
            <div className="col-lg-4"></div>
            <div className="col-lg-4"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
